import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { LoggerService } from '@app/shared/services/logger.service';
import { ProgressBagEvents } from '../progressbag-events.service';
import { Observable } from 'rxjs';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { takeUntil } from 'rxjs/operators';
import { SharedModule } from '@app/shared/shared.module';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { ThemingService } from '@app/shared/services/theming.service';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-animated-asset',
  templateUrl: './animated-asset.component.html',
  styleUrls: ['./animated-asset.component.scss'],
  animations: [
    trigger('hasToGrow', [
      state('true', style({ opacity: 1, height: '100%', top: '-1em' })),
      state('false', style({ opacity: 0, height: 0, top: '100%' })),
      transition('true => false', animate('500ms cubic-bezier(.74,-0.2,.87,.61)')),
      transition('false => true', animate('500ms ease-out')),
    ]),
  ],
  standalone: true,
  imports: [SharedModule],
})
export class AnimatedAssetComponent implements OnInit {
  public logger = inject(LoggerService);
  private progressBagEvents = inject(ProgressBagEvents);
  private themingService = inject(ThemingService);

  @Input() progressStep: number;
  @Input() event: LimitedTimeEvent;

  componentDestroy: () => Observable<unknown>;

  currentImage = signal<string>('');
  hasToGrow = signal<boolean>(true);
  img = signal<number>(0);

  ngOnInit(): void {
    this.setCurrentImage(this.progressStep - 1);

    this.progressBagEvents.milestoneAction$.pipe(takeUntil(this.componentDestroy())).subscribe({
      next: (step: number) => {
        this.toggleGrow(step);
      },
      error: (error) => {
        this.logger.error(error);
      },
    });
  }

  toggleGrow(assetStep: number): void {
    this.hasToGrow.update((v) => !v);

    setTimeout(() => {
      this.setCurrentImage(assetStep);
      this.hasToGrow.update((v) => !v);
    }, 500);
  }

  setCurrentImage(progressStep: number): void {
    if (!this.event.assets) {
      this.currentImage.set(this.themingService.getThemeAsset('progressivebag', `tree-step-${progressStep + 1}`));
    } else {
      this.currentImage.set(
        this.themingService.getOverrideThemeAsset(this.event.assets, `tree-step-${progressStep + 1}`)
      );
    }
  }
}
